export default function () {

  function iconSizeHandle() {
    $('.c-icon--blank2').each(function() {
      $(this).removeAttr('style');
      let w = $(this).width();
      let h = $(this).height();
      let s = Math.floor(w);

      if(s % 2 != 0) {
        s += 1;
      }

      let $span = $(this).find('span');
      $span.removeAttr('style');
      let ss = Math.floor(s * .8);

      $(this).css({width: s + 'px', height: s + 'px'});
      $span.css({width: ss + 'px', height: ss + 'px'});
      $span.eq(0).css({left: s - ss + 'px'});
      $span.eq(1).css({top: s - ss + 'px'});
    });
  }
  iconSizeHandle();
  $(window).on('resize', iconSizeHandle);
}
